export default __webpack_public_path__ + "static/media/DeleteUploadIcon.47e4edb1.svg";